import $ from 'jquery';
import React, { Fragment, useState } from "react";
import FormularioModalAtendimento from "./FormularioModalAtendimento";
import AtendimentoProvider from "../../../Pages/Operacoes/Atendimento/Atendimento/AtendimentoContext";


import "./ModalAtendimento.css";

function initialState() {
  return {
    cliclRealizado: false
  };
}

const ModalAtendimento = ({ children = null, filaAtendimentoId = 0, titulo = null, visaoExclusiva = null, eventModalCallBack = () => { } }) => {
  const [modalAtendimentoValues, setModalAtendimentoValues,] = useState(initialState());

  function showModal() {
    $(`#modalModalAtendimento${filaAtendimentoId}${visaoExclusiva}`).modal('show');
    setModalAtendimentoValues({
      ...modalAtendimentoValues,
      cliclRealizado: true
    });
  }

  function saveHandlerCallBack() {
    $(`#modalModalAtendimento${filaAtendimentoId}${visaoExclusiva}`).modal('hide');
    setModalAtendimentoValues({
      ...modalAtendimentoValues,
      cliclRealizado: false
    });

    setTimeout(() => {
      eventModalCallBack();
    }, 700);
  }

  return (
    <Fragment>
      <div className="row compomenteModalAtendimentoBorda">
        <div className="col-12 col-md-12">
          <span role="button"
            onClick={showModal}
          >
            {children == null ? <button
              className={`btn btn-default`}
            >
              Realizar Atendimento Lead
            </button> : children}
          </span>

        </div>
      </div>

      <div
        className="modal fade"
        id={`modalModalAtendimento${filaAtendimentoId}${visaoExclusiva}`}
        tabIndex="-1"
        role="dialog"
        aria-labelledby={`modalModalAtendimento${filaAtendimentoId}${visaoExclusiva}Label`}
        aria-hidden="true"
      >

        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h5
                className="modal-title"
                id={`modalModalAtendimento${filaAtendimentoId}${visaoExclusiva}Label`}
              >
                {titulo ? titulo : "Atendimento"}
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body componenteAtendimentoModalAtendimento_modalBody">
              <Fragment>

                <AtendimentoProvider saveHandlerCallBack={saveHandlerCallBack}>
                  {modalAtendimentoValues.cliclRealizado ? (<div className="container-fluid pl-3 pt-3 pb-3">{<FormularioModalAtendimento filaAtendimentoId={filaAtendimentoId} />}</div>) : null}
                </AtendimentoProvider>

              </Fragment>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
              >
                Fechar
              </button>
            </div>
          </div>
        </div>

      </div >
    </Fragment >
  );
};

export default ModalAtendimento;
